import { PageResponseModel } from "../common/models";
import api, { ApiResponse } from "./../api";
import { TerminalLogItem,TerminalLogFilterModel } from "./models";
import axios from "axios";


export const REQUEST_ID: {
    [key: string]: string;
  } = {
    GET_TERMINAL_LOG: "get_terminal_log",
    GET_TERMINALS_LOG: "get_terminals_log",
  };
 

class TerminalChangelogService {
  private source: any;
  private static instance: TerminalChangelogService;

  private constructor() {
    this.source = {};
  }

  static getInstance(): TerminalChangelogService {
    if (!TerminalChangelogService.instance) {
      TerminalChangelogService.instance = new TerminalChangelogService();
    }
    return TerminalChangelogService.instance;
  }

  public cancelRequest = (requestId: string) => {
    this.source[requestId] && this.source[requestId].cancel();
  };

  /**
   * Fetch all terminal activity logs for a single terminal with filters + pagination
   */
  public getTerminalsLog = async (
    terminalNumber: string,
    filter: TerminalLogFilterModel,
    page?: number
  ): Promise<ApiResponse<PageResponseModel<TerminalLogItem>>> => {
    const params = new URLSearchParams();

    for (const property in filter) {
      if (!property) continue;
      filter[property as keyof TerminalLogFilterModel] &&
        params.append(
          property,
          filter[property as keyof TerminalLogFilterModel] || ""
        );
    }
    
    page && params.append("page", page.toString());

    this.cancelRequest(REQUEST_ID.GET_TERMINALS_LOG);
    this.source[REQUEST_ID.GET_TERMINALS_LOG] = axios.CancelToken.source();

    return await api.get(`/terminals/activity-log/${terminalNumber}`, {
      params,
      cancelToken: this.source[REQUEST_ID.GET_TERMINALS_LOG].token,
    });
  };
}

export default TerminalChangelogService.getInstance();